import { electronicFormatIBAN, isValidIBAN } from 'ibantools';
import { addMethod, string } from 'yup';

addMethod(string, 'iban', function (message) {
  return this.test('iban-test', message, (value) => {
    const formattedValue = electronicFormatIBAN(value);
    return formattedValue ? isValidIBAN(formattedValue) : false;
  });
});
